import PropTypes from 'prop-types'
import { Row } from '../../../../common/table/Row'
import { CollapseRow } from './CollapseRow'

export const FilterTableBody = ({
  ids,
  getDataFromRedux,
  schema,
  onRowClick,
}) => {
  return (
    <tbody>
      {ids.map((id, rowIndex) => {
        if (id.includes('shortContent')) {
          return <CollapseRow key={id} id={id} rowIndex={rowIndex} />
        }

        return (
          <Row
            key={id}
            getDataFromRedux={getDataFromRedux}
            onRowClick={onRowClick}
            rowId={id}
            rowIndex={rowIndex}
            schema={schema}
          />
        )
      })}
    </tbody>
  )
}

FilterTableBody.propTypes = {
  ids: PropTypes.array.isRequired,
  getDataFromRedux: PropTypes.func.isRequired,
  schema: PropTypes.array.isRequired,
}

FilterTableBody.defaultProps = {}
